import { render, staticRenderFns } from "./ViewUnblockVendor.vue?vue&type=template&id=0ded1c36&"
import script from "./ViewUnblockVendor.vue?vue&type=script&lang=js&"
export * from "./ViewUnblockVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports